module.exports = "../../../../platform/assets/pageMainIcon/ig-basic-archives-5.svg";